import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/components/common/ErrorSplash.css';

const ErrorSplash = ({ message }) => {
  const navigate = useNavigate();
  return (
    <div className="error-splash">
      <div className="error-message">
        <p>{message}</p>
        <button onClick={() => navigate('/')} className="error-button">Home</button>
      </div>
    </div>
  );
};

export default ErrorSplash;
